<template>
  <div style="background: linear-gradient(to bottom,#1f1c1f 0,#1f1c1f 100%);">
    <div>
      <van-nav-bar :title="$t('video.video')" class="header_b">

      </van-nav-bar>
    </div>
    <div class="video_box">
      <div class="nav_box_w region-tabs">
        <div class="n_item" :class="{active:id===888}" @click="onChange(888)">{{$t('video.latest')}}</div>
        <div class="n_item" :class="{active:id===8}" @click="onChange(8)">{{$t('latin_region')}}</div>
        <div class="n_item" :class="{active:id===1}" @click="onChange(1)">{{$t('asia_region')}}</div>
      </div>
      <div class="" style="height: 10px;"></div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <div class="list-item">
            <div class="movie-list-item" v-for="(i, key) in data" :key="key" @click="toPlayVideo(i)">
              <div class="imb_box">
                <img :src="i.vod_pic" class="van_img" />
                <div class="access-tag" :class="{free:Number(i.seen_status)===1}">{{Number(i.seen_status)===1 ? $t('free_video') : 'VIP'}}</div>
                <div class="cc_zan">{{ $t("video.play") }} :{{ i.count
                    }}</div>
              </div>
              <div class="c_yy">{{ videoTitle(i.vod_name) }}</div>
            </div>

          </div>

        </van-list>
      </van-pull-refresh>
    </div>
    <div style="height: 55px;"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      navSel:0,
      navSel2:0,
      list: [],
      nav2list:[this.$t('q55'),this.$t('q56'),this.$t('q57')],
      loading: false,
      finished: false,
      refreshing: false,
      videolitem: [],
      data: [],
      page: 1,
      id: 888,
      userVip: null,
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale || localStorage.getItem('lang') || 'ja';
    }
  },
  methods: {
    videoTitle(title) {
      return this.common.pickLangText(title || '', '|||', this.currentLocale);
    },
    onLoad(isRefresh = false) {
      if (isRefresh) {
        this.page = 1;
        this.data = [];
      }

      this.loading = true;

      this.getVideoList().then(() => {
        this.loading = false;
        if (this.refreshing) {
          this.refreshing = false;
          Toast(this.$t("reservation.refresh"));
        }
      });
    },
    onChange(name) {
      this.id = name;
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.data = [];
      this.onLoad(true);

    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.loading = true;
      this.onLoad(true);
    },
    toPlayVideo(item) {
      const openVideo = () => {
        if (Number(item.seen_status) !== 1 && this.userVip < 1) {
          this.$toast(this.$t('vip_video_required'));
          return;
        }
        this.$router.push({ path: "/PlayVideo", query: { id: item.id } });
      };
      if (this.userVip === null) {
        this.getUserInfo().then(openVideo);
        return;
      }
      openVideo();
    },
    getUserInfo() {
      if (!localStorage.getItem('token')) {
        this.userVip = 0;
        return Promise.resolve();
      }
      return this.$http({ method: 'get', url: 'user_info' }).then((res) => {
        if (res && res.code === 200 && res.data) {
          this.userVip = Number(String(res.data.vip || '0').replace(/[^0-9]/g, '')) || 0;
        } else {
          this.userVip = 0;
        }
      }).catch(() => {
        this.userVip = 0;
      });
    },
    getVideoList() {
      return new Promise((resolve, reject) => {
        this.$http({
          method: "get",
          data: { id: this.id, page: this.page },
          url: "video_list",
        }).then((res) => {
          if (res.data && res.data.data && res.data.data.length > 0) {
            this.data = this.data.concat(res.data.data);
            this.page++;
            resolve();
          } else {
            this.finished = true;
            resolve();
          }
        }).catch((error) => {
          console.error("Error fetching video list:", error);
          reject(error);
        });
      });
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getVideoClass() {
      this.$http({
        method: "get",
        url: "video_class",
      }).then((res) => {
        this.videolitem = res.data || [];
        const obj = { id: 888, name: this.$t('video.latest') };
        this.videolitem.unshift(obj);
        const locale = this.$i18n.locale || localStorage.getItem('lang') || 'ja';
        this.videolitem.forEach((item) => {
          if (item.id !== 888) {
            item.name = this.common.pickLangText(item.name, ',', locale);
          }
        });


      });
    },
  },
  created() {
    this.getVideoClass();
    this.getUserInfo();

  },
};
</script>

<style scoped lang="less">
.van-nav-bar {
  background: linear-gradient(to bottom, #1f1c1f 0, #1f1c1f 100%);
}
.header_b{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.video_box{
  padding-top: 100px;
  /deep/ .van-tabs__nav{
    background: linear-gradient(120deg,#212121,#313131);
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
  }
  .nav_box_w{
    display: flex;
    background: linear-gradient(120deg,#212121,#313131);
    padding: 20px;
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
    flex-wrap: wrap;
    .n_item{
      color: #fff;
      padding: 2px 16px;
      border-radius: 40px;
      margin-right: 20px;
      &.active{
        background:linear-gradient(90deg,#efcba7,#dcab76) ;
        color: #623a13;
        
      }
    }
  }
  .c_yy{
    width: 100%;
    overflow: hidden; /* 确保超出容器的内容被裁剪 */
    white-space: nowrap; /* 确保文本在一行内显示 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
    color: #c7c7c7;
    font-size: 30px;
    padding: 12px 0 30px;
  }
  .movie-list-item{
    .imb_box{
      position: relative;
      .van_img{
        height: 300px;
        width: 100%;
        border-radius: 20px;
      }
      .cc_zan{
        position: absolute;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 20px 0;
        color: #fff;
        bottom: 26px;
        right: 26px;
        font-size: 24px;
        padding: 2px 16px;
      }
      .access-tag{position:absolute;top:12px;left:12px;border-radius:12px;padding:6px 12px;background:#6b4b35;color:#fff;font-size:20px;}
      .access-tag.free{background:#16a34a;}
    }
  }
}
/deep/ .van-tabs__wrap {
  height: 13vw;
  padding-bottom: 10px;
}

/deep/ .van-tabs__line {
  background-color: #c571cf;
}

/deep/ .van-loading__text {
  font-size: 32px;
  color: #000;

}

/deep/ .van-list__finished-text {
  font-size: 32px;
  color: #000;

}

/deep/ .van-pull-refresh__head {
  height: 100px;
}

/deep/ .van-pull-refresh__text {
  font-size: 32px;
  /* 设置字体大小 */
  color: #000;

}

.list-item {
  display: flex;
  width: calc(100% - 7vw);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}

.movie-list-item {
  width: calc(50% - 12px);

}

.cover_img {
  border-radius: 20px;
}

.movie-list-item-bottom {
  position: relative;
  width: 100%;
  bottom: 6vw;
}

.movie-time-div {
  background-color: rgba(0, 0, 0, 0.4);
  height: 8vw;
  color: #fff;
  border-radius: 0 0 40px 40px;
}

.movie-list-item-bottom div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 24vw;
  padding-left: 16px;
  font-size: 3vw;
}

.activeBg {
  color: rgb(197, 113, 207);
  font-weight: bold;
  background: url('/img/new.png') right top 5px / 30% no-repeat;
}
</style>
